import Audio from '@/lib/audio.js';
import Cards from '@/lib/cards.js';
import isMobile from '@/lib/navigation-is-mobile';
import { mountVueComponent } from '@/lib/mount-vue-component.js';
import { registerAutosaveCommentListeners } from '@/lib/autosaver-comment';
import stickybits from 'stickybits';
import VideoThumbnails from '@/lib/video-thumbnails.js';

export default function () {
	if (!isMobile()) {
		stickybits('.header-controls', { useStickyClasses: true });
	}

	const cards = new Cards();
	cards.setup('ul.cards:not(.vertical-gallery)', 'li', 'fitRows');

	const audio = new Audio();
	audio.setup('jp-jplayer');

	const videoThumbnails = new VideoThumbnails();
	videoThumbnails.setup('preview-container.video');

	const voteButton = document.querySelector('button.control.vote-button');
	const unvoteButton = document.querySelector('button.action-button.btn-unvote');
	registerAutosaveCommentListeners([voteButton, unvoteButton]);

	import('@/lib/components/Video/VideoPlayer').then((videoPlayer) => {
		mountVueComponent('video-player', videoPlayer);
	});

	import('@/lib/components/Video/VideoModal.vue').then((videoModal) => {
		mountVueComponent('video-modal', videoModal);
	});

	/** Comments */
	import('@/lib/components/Comments/Comments.vue').then((comments) => {
		mountVueComponent('comments', comments);
	});

	/** Help Icon */
	import('@/lib/components/Shared/HelpIcon.vue').then((helpIcon) => {
		mountVueComponent('help-icon', helpIcon);
	});

	import('@/lib/components/QuickManager/QuickManager.vue').then((quickManager) => {
		mountVueComponent('quick-manager', quickManager);
	});

	import('@/lib/components/Shared/PdfViewer/PdfViewer.vue').then((pdfViewer) => {
		mountVueComponent('pdf-viewer', pdfViewer);
	});

	import('@/lib/components/Fields/AIAgentField.vue').then((aiAgentField) => {
		mountVueComponent('ai-agent-field', aiAgentField);
	});
}
